import { render, staticRenderFns } from "./ShowCompanyUsersPage.vue?vue&type=template&id=324cf00b&scoped=true"
import script from "./ShowCompanyUsersPage.vue?vue&type=script&lang=js"
export * from "./ShowCompanyUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324cf00b",
  null
  
)

export default component.exports